import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachPricingRuleDto, SetCoachPricingInputRulesDto } from "../../../models/coach/dto/coach-pricing-rule.dto";
import { GET_COACHS_QUERY_KEY } from "../../coach-management/hooks/useListCoachs";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";

export const useSetCoachPricingRules = (onSuccess: (newData: CoachPricingRuleDto[]) => void) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();
    return useMutation({
        mutationKey: ['set-coach-pricing-rules'],
        mutationFn: async (body: { rules: SetCoachPricingInputRulesDto }) => {
            return client.fetchApi<CoachPricingRuleDto[], SetCoachPricingInputRulesDto>({
                method: 'POST',
                endpoint: 'coach-pricing',
                body: body.rules
            });
        },
        onSuccess: (data) => {
            onSuccess(data);
            if (selectedOrganization?.id) {
                queryClient.invalidateQueries(GET_COACHS_QUERY_KEY(selectedOrganization.id));
            }
        }
    });
}
